
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us-economy/us-consumer",
      function () {
        return require("private-next-pages/us-economy/us-consumer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us-economy/us-consumer"])
      });
    }
  